import useCommentsState from 'state/useCommentsState';
import { ICommentsAndObservations } from 'types/global';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import { submitComment } from 'views/LogisticServices/utils/general.utils';

export const useComments = () => {
  const { comments, loadingComments, setLoadingComments } = useCommentsState();

  const uploadComment = async ({
    orderId,
    logisticServiceId,
    assignedKamId,
    comment
  }: {
    orderId: number | undefined;
    logisticServiceId: number | undefined;
    assignedKamId?: number;
    comment: ICommentsAndObservations;
  }) => {
    setLoadingComments(true);
    try {
      if (!orderId && !logisticServiceId) return;

      const kamUserId = assignedKamId ? Number(assignedKamId) : undefined;
      const commentToSend = {
        orderId: orderId as string | number,
        logisticServiceId: logisticServiceId as string | number,
        allowNewCommentsSubmission: !loadingComments,
        handleLoading: setLoadingComments,
        comments: comment.comments,
        mentions: comment.mentions || [],
        commentImage: comment?.commentImage,
        ...(kamUserId && { kamUserId: kamUserId })
      };

      await submitComment(commentToSend);

      return true;
    } catch (error) {
      displayErrorNotification({ customJSXMessage: <>Error enviando el comentario</> });
    } finally {
      setLoadingComments(false);
    }
  };

  return { comments: comments || [], isLoading: loadingComments, uploadComment };
};
